import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { IFulfillmentGroup } from '../../../models/order-details';
import { returnDatePurchaseHistoryText } from '../../../utils/order-history/card-utils';

interface IReturnDate {
  fg: IFulfillmentGroup;
  bold?: boolean;
}
const ReturnDate = ({ fg, bold = true }: IReturnDate) => {
  return (
    <div className="sui-flex sui-flex-col">
      <Typography variant="body-base" weight={`${bold ? 'bold' : 'regular'}`}>
        {returnDatePurchaseHistoryText(fg)}
      </Typography>
    </div>
  );
};

export default ReturnDate;
